import React, { useState } from 'react'
import Header from '../component/Header'
import BottomBar from '../component/BottomBar'
import './contact.css'
import { FaAngleRight } from 'react-icons/fa6'
import { Helmet } from 'react-helmet-async'

function Contact() {

    const [msg, setmsg] = useState('')

  return (
    <>
        <Helmet>
            <title>Contact Us | The Lord Nations Foundation</title>
            <meta name="description" content="Get in touch with The Lord Nations Foundation. Reach out for inquiries, support, or partnership opportunities. We’re here to help!" />
        </Helmet>
        <div className='about_container' >
            <Header/>
            <div className='about_head_spacer'></div>
            <div className='contact_banner' >
                <div className='about_banner_overlay'>
                    <div className='contact_banner_label' >
                        <h3>Contact Us</h3>
                    </div>
                </div>
            </div>

            <div className='contact_form' >
                <h3>SUBMIT AN ENQUIRY</h3>
                
                <div className='contact_form_fst_input' >
                    <input placeholder='First Name' />
                    <input placeholder='Last Name' />
                </div>

                <input placeholder='Email' />

                <select>
                    <option>- Select -</option>
                    <option>Accounting Queries</option>
                    <option>Careers</option>
                    <option>Complaints</option>
                    <option>Donations</option>
                    <option>Media</option>
                    <option>Pertnership</option>
                    <option>Supply Chain Queries</option>
                    <option>Others</option>
                </select>

                <textarea value={msg} maxLength="200" onChange={(e)=>setmsg(e.target.value)} placeholder='Message' />

                <p>200 characters max {msg.length > 0 ? <>({msg?.length} remaining)</> : null}</p>

                <small>
                    By clicking on the submit button, you confirm that you are over 18 and agree to The Lord Nations Foundation emailing you about how we're changing the lives of children – and how you can help. If you include your telephone number, we may also contact you by phone.  You can opt-out at any time. For more information on how we use your data, see our privacy policy.
                </small>

                <div className='contact_btn' >
                    <h3>CONTACT US</h3>
                    <FaAngleRight/>
                </div>
            </div>

            <BottomBar/>
        </div>
    </>
  )
}

export default Contact